import { useMemo } from 'react';
import useProjectId from '@hooks/useProjectId';
import { skipToken } from '@reduxjs/toolkit/query';
import { useGetProjectDomainsQuery } from '@store/services/projects';
import { parseDomains } from '@utils/helpers';

const useParsedDomains = () => {
  const projectId = useProjectId();

  const { data: projectDomains } = useGetProjectDomainsQuery(
    projectId || skipToken,
  );

  return useMemo(() => parseDomains(projectDomains ?? []), [projectDomains]);
};

export default useParsedDomains;
